import 'css-chunk:src/components/form-fields/checkbox-component/checkbox-component.module.scss';export default {
  "checkbox-component": "checkbox-component_checkbox-component__ecz3R",
  "inline": "checkbox-component_inline__qxTml",
  "pill-wrapper": "checkbox-component_pill-wrapper__KaMoe",
  "pill-close": "checkbox-component_pill-close__YQ36R",
  "pill": "checkbox-component_pill__j-LLl",
  "label-text": "checkbox-component_label-text__yFRFf",
  "unselected-pill": "checkbox-component_unselected-pill__JJ8nX",
  "selected-pill": "checkbox-component_selected-pill__Omf-h",
  "pill-closable": "checkbox-component_pill-closable__t7uTi",
  "container": "checkbox-component_container__icu6C",
  "checkbox-custom": "checkbox-component_checkbox-custom__QpmzW",
  "checkbox-custom-label": "checkbox-component_checkbox-custom-label__E1OeL",
  "checkmark-selected": "checkbox-component_checkmark-selected__Z40Tb",
  "checkmark-unselected": "checkbox-component_checkmark-unselected__JrD-l",
  "checkbox-custom-selected": "checkbox-component_checkbox-custom-selected__Il9yt"
};